import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Verification() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Verification
			</Text>
			<Text variant='caption' gutterBottom>
				Verification
			</Text>
		</Paper>
	)
}
export default Verification
